import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c43a924"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import appHost, { OpenNewPageParams } from '@/utils/app'
import AppHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'redirect',
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const type = ($route.query.type as string) || ''
const title = ($route.query.title as string) || ''
const afterOpen = ($route.query.afterOpen as string) || ''
const target = computed(() => {
  const value = ($route.query.target as string) || ''
  return decodeURIComponent(value)
})

const useSystem = type === 'system'
const useNewPage = type === 'newPage'

const message = computed(() => {
  if (useSystem) {
    return '已在系统浏览器打开页面'
  } else if (useNewPage) {
    // 若没有指定关闭当前页面，则显示文案即可
    return '已打开新页面'
  }
  return ''
})

function afterOpenHandle() {
  if (afterOpen === 'close') {
    appHost.goAppBack()
  } else if (afterOpen === 'back') {
    $router.go(-1)
  }
}
if (useSystem) {
  appHost.openBrowser(target.value)
  afterOpenHandle()
} else if (useNewPage) {
  let jsonConfigStr = ($route.query.jsonConfig as string) || ''
  let jsonParams: Partial<OpenNewPageParams> = {}
  try {
    jsonParams = JSON.parse(jsonConfigStr)
  } catch (error) {
    console.log('error', error)
  }
  console.log('jsonParams', jsonParams)
  appHost.openNewPage({
    url: target.value,
    title,
    ...jsonParams,
  })
  afterOpenHandle()
} else {
  location.replace(target.value)
}

function onLeftClick() {
  appHost.goAppBack()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(message)), 1))
}
}

})